import {createContext} from 'react';

export const BundlesListContext = createContext({});
